import { api, type QueryParams } from '@/lib/api/client';
import type { Locale, Paginated, Role, User } from '@/lib/api/types';

export interface CreateUserBody {
  email: string;
  name: string;
  role: Role;
  locale: Locale;
  password: string;
}

/** Partial update — only provided fields change (management.md §User management). */
export interface UpdateUserBody {
  name?: string;
  role?: Role;
  locale?: Locale;
  is_active?: boolean;
  password?: string;
}

/** Admin user administration (spec §15.1, requires users:manage). */
export const usersApi = {
  async list(params?: QueryParams): Promise<Paginated<User>> {
    const res = await api.getRaw<User[]>('/admin/users', params);
    return { data: res.data ?? [], meta: { pagination: res.meta!.pagination! } };
  },
  create(body: CreateUserBody): Promise<User> {
    return api.post<User>('/admin/users', body);
  },
  update(id: string, body: UpdateUserBody): Promise<User> {
    return api.patch<User>(`/admin/users/${id}`, body);
  },
  remove(id: string): Promise<null> {
    return api.del(`/admin/users/${id}`);
  },
};
